import { MenuItem } from "@mui/material";
import React from "react";
import { DropDownOption } from "../../../models/DropDownOption";

const MenuItemsForDropdown = (set: string, options: DropDownOption[]) => {
  const ret = options.filter((ddo: DropDownOption) => {
    return ddo.set === set;
  }).sort((a: DropDownOption, b: DropDownOption) => {
    return a.seq - b.seq;
  });

  return ret.map((item: DropDownOption) => {
    if (item.description.indexOf("/") > -1) {
      return item.description.split("/").reverse().map((subitem, si) => {
        return React.createElement(MenuItem, {
          key: item.value + "_" + si,
          value: item.value + "_" + si,
          disabled: item.disabled ?? false,
        }, subitem.trim());
      });
    } else {
      return React.createElement(MenuItem, {
        key: item.value,
        value: item.value,
        disabled: item.disabled ?? false,
      }, item.description);
    }
  });
};

export default MenuItemsForDropdown;